/**
 * The header rows of the force & commands and admin panels, in the order
 * `getSettingsHeaderData` lists them. A panel passes a row's number to the
 * edit/cancel/apply handler, which reads it through these names.
 */
export const SETTINGS_HEADERS = Object.freeze({
  ESS: 0,
  TGS: 1,
  TES: 2,
  HEATING_PLATFORMS: 3,
  TRACK_EQUIPMENT: 4,
  SYSTEM_COMMANDS: 5,
});
